import { Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { authSelectors } from 'app/auth/store/userSlice';
import jwtService from 'app/services/jwtService';
import { IMPERSONATION_TRANSLATION_KEY } from 'app/impersonation/i18n';
import { getImpersonatedCompanyFromToken } from 'app/impersonation/impersonationSession';

const BANNER_STYLE = { border: '#FEDF89', background: '#FFFAEB', text: '#B54708' };
const SIGN_IN_PATH = '/sign-in';

const exitImpersonation = () => {
  const storedToken = jwtService.getAccessToken();
  if (storedToken && storedToken === jwtService.getTabAccessToken()) {
    // The stored session is this tab's read-only session: remove it.
    jwtService.logout();
  } else {
    // Another tab has stored its own session since: leave it alone.
    jwtService.clearTabSession();
  }
  // Works when the back office opened this tab; browsers ignore it otherwise.
  window.close();
  setTimeout(() => {
    if (!window.closed) {
      window.location.replace(SIGN_IN_PATH);
    }
  }, 100);
};

export default function ImpersonationBanner() {
  const { t } = useTranslation(IMPERSONATION_TRANSLATION_KEY);
  const impersonation = useSelector(authSelectors.selectImpersonation);
  const companyName = useSelector(authSelectors.selectCompanyName);

  if (!impersonation) {
    return null;
  }

  const company = companyName || getImpersonatedCompanyFromToken();

  return (
    <div
      role="status"
      style={{
        height: '40px',
        width: '100%',
        boxSizing: 'border-box',
        border: `1px solid ${BANNER_STYLE.border}`,
        backgroundColor: BANNER_STYLE.background,
        display: 'flex',
        justifyContent: 'center',
        gap: '8px',
        alignItems: 'center',
      }}
    >
      <Typography variant="bodyMMedium" sx={{ color: BANNER_STYLE.text }}>
        <strong>{company ? t('BANNER_TEXT', { company }) : t('BANNER_TEXT_NO_COMPANY')}</strong> ·
      </Typography>

      <Button variant="contained" color="primary" className="h-[24px]" onClick={exitImpersonation}>
        {t('EXIT')}
      </Button>
    </div>
  );
}
